<template>
  <div>
    <audio id="mediafile-audio" style="display: none" src=""></audio>
    <h2 class="form-section-header">{{ title }}</h2>
    <div class="flex">
      <el-select
        v-if="multiple"
        v-model="meIds"
        style="width: 100%"
        :placeholder="`Select ${title}`"
        :multiple="true"
        clearable
        filterable
        @change="onMediafilesSelection"
      >
        <template slot="prefix">
          <span style="opacity: 0;">Files</span>
        </template>
        <el-option
          v-for="(media, index) in mediafileOptions"
          :key="index"
          :label="media.name"
          :value="media.id"
        />
      </el-select>
      <DadsSelect
        v-else
        v-model="meId"
        style="width: 100%"
        :placeholder="`Select ${title}${required ? '*' : ''}`"
        :multiple="false"
        clearable
        filterable
        @change="onMediafileSelection"
      >
        <template slot="prefix">{{ title }}</template>
        <el-option
          v-for="(media, index) in mediafileOptions"
          :key="index"
          :label="media.name"
          :value="media.id"
        />
      </DadsSelect>
      <div v-if="meId" class="mediafile-controls-flex flex align-center ml-5">
        <el-tooltip placement="top" content="Preview media">
          <el-button
            v-loading="mediafilePlayPending"
            class="mediafile-play-button"
            :disabled="!meId"
            :icon="mediafileIsPlaying ? 'mdi mdi-pause' : 'mdi mdi-play'"
            @click="mediafileIsPlaying ? pauseFile() : playFile()"
          />
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import feathersClient from "@/feathers/feathers-client";
import DadsSelect from "@/components/select";

export default {
  name: "ExistingMediafile",
  props: {
    selectedMeId: { default: null },
    selectedMeIds: { default: null },
    title: { required: true },
    defaultMessage: { default: false },
    newMediafile: { default: null },
    multiple: { default: false },
    clearState: { required: true },
    globalsOnly: { default: false },
    required: { default: false },
  },

  components: { DadsSelect },

  data() {
    return {
      meId: null,
      meIds: [],
      mediafileOptions: null,
      mediafileIsPlaying: false,
      mediafileBlob: null,
      mediafilePlayPending: false
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    }
  },

  watch: {
    newMediafile(media) {
      if (media) {
        this.mediafileOptions.push(media);
      }
    },

    multiple() {

      if(this.multiple) {
        this.meIds = this.meId ? [this.meId] : [];
        this.meId = null;
        return;
      }

      if(this.selectedMeId){
        this.meId = this.selectedMeId;
      } else {
        this.meId = this.meIds.length ? this.meIds[0] : null;
        this.$emit("mediafilesSelected", this.meId ? [this.meId] : []);
      }

    },

    selectedMeId: {
      immediate: true,
      handler(val) {
        this.meId = val == null ? null : val;
      }
    },

    selectedMeIds: {
      immediate: true,
      handler(val) {
        this.meIds = val && val.length ? [...val] : [];
      }
    },

    clearState(val) {

      if (val) {
        this.pauseFile();
        this.meId = null;
        if (this.defaultMessage) {
          this.meId = 0;
        }
        this.meIds = [];
        this.mediafileIsPlaying = false;
        this.mediafileBlob = null;
        this.mediafilePlayPending = false;
      }
    },

    meId(val) {
      this.mediafileBlob = null;
    },

    selectedTenant() {
      if (!this.globalsOnly) {
        this.queryMediafiles();
      }
    }
  },

  methods: {
    onMediafilesSelection() {
      this.$emit("mediafilesSelected", this.meIds);
    },

    onMediafileSelection() {
      this.$emit("mediafileSelected", this.meId);
    },

    async fetchMediafile(recordId) {
      await feathersClient
        .service("mediafiles")
        .get(recordId)
        .then(res => {
          this.setAudioBlob(res.recording);
        })
        .catch(() => true);
    },

    setPlayPending() {
      this.mediafilePlayPending = !this.mediafilePlayPending;
    },

    async playFile() {
      this.setPlayPending();
      await this.fetchMediafile(this.meId);
      this.setPlayPending();
      if (!!this.mediafileBlob) {
        this.mediafileAudioElement.play();
        this.mediafileIsPlaying = true;
      }
    },

    pauseFile() {
      this.mediafileIsPlaying = false;
      this.mediafileAudioElement.pause();
      this.mediafileAudioElement.currentTime = 0;
    },

    setAudioBlob(uri) {
      this.mediafileBlob = uri;
      this.mediafileAudioElement.src = this.mediafileBlob;
    },

    queryMediafiles() {
      feathersClient
        .service("mediafiles")
        .find({
          query: {
            tenantId: this.globalsOnly
              ? 0
              : { $in: [0, this.selectedTenant.id] },
            $sort: {
              name: 1
            }
          }
        })
        .then(res => {
          if (this.defaultMessage) {
            this.mediafileOptions = [
              { name: "Default message", id: 0 },
              ...res
            ];
            if (this.multiple && this.meIds.length === 0) {
              this.meIds.push(0);
            } else if (!this.meId) {
              this.meId = 0;
            }
          } else {
            this.mediafileOptions = res;
          }
        })
        .catch(() => true);
    }
  },

  created() {
    this.queryMediafiles();
  },

  mounted() {
    this.mediafileAudioElement = document.getElementById("mediafile-audio");
    this.mediafileAudioElement.addEventListener("ended", () => {
      this.mediafileIsPlaying = false;
    });
  }
};
</script>

<style lang="scss" scoped>
.mediafile-play-button {
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
}

hr {
  opacity: 0.25;
}
</style>
